export default function About() {
  return (
    <section id="about" className="section">
      <div className="container split split--5-7">
        <div>
          <div className="eyebrow">The club</div>
          <h2
            className="display display--lg"
            style={{ marginTop: "1rem", marginBottom: 0 }}
          >
            one book,
            <br />
            one month,
            <br />
            one group chat
            <br />
            of best friends.
          </h2>
        </div>
        <div className="stack-lg" style={{ marginTop: "1.25rem" }}>
          <p style={{ fontSize: "var(--t-body-lg)", lineHeight: 1.6 }}>
            Manteca Book Besties is a women's reading club rooted in the 209.
            We pick one book together, give it a month, and meet up to talk
            about what landed, what didn't, and what it stirred up.
          </p>
          <p style={{ lineHeight: 1.7 }}>
            It's small on purpose. The vibe is closer to a long lunch with
            smart friends than a syllabus. There's no required word count, no
            performance, and no judgment if life got busy and you only made
            it halfway. Show up anyway. We saved you a seat.
          </p>
          <hr className="rule" />
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: "1.25rem",
            }}
          >
            <Stat label="A book" value="every month" />
            <Stat label="Meet ups" value="in person" />
            <Stat label="Membership" value="$5 / month" />
          </ul>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <li>
      <div className="eyebrow" style={{ color: "var(--c-aqua)" }}>
        {label}
      </div>
      <div
        className="display display--sm"
        style={{ marginTop: "0.35rem", fontStyle: "normal" }}
      >
        {value}
      </div>
    </li>
  );
}
